import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import React, {Component} from 'react';
import {connect} from 'react-redux';
import UserDimeCardList from '../components/UserDimeCardList';
import PinterestSearchBox from '../components/PinterestSearchBox';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import {App, uFirstName, uLastName, uRating, uId, uImage, uIsSignedIn} from '../containers/App';
import { FaSignOutAlt, FaUser, FaUsers, FaHome, FaPlus } from "react-icons/fa";
import {setSearchField, requestRobots } from '../actions';
import { getSecureItem } from '../utils/encryption';
import env from "react-dotenv";

let URL = `${env.API_URL}/getDimes`;

const mapStateToProps = state => {
  return{
    searchField: state.searchRobots.searchField,
    robots: state.requestRobots.robots,
    ispending: state.requestRobots.ispending,
    error: state.requestRobots.error
  }
}

const mapDispatchToProps = (dispatch) => {
  return{
    onSearchChange: (event) => dispatch(setSearchField(event.target.value)),
    onRequestRobots: () => dispatch(requestRobots())
  }
}

class UserDimes extends Component{
  constructor() {
    super();
    
    const savedState = this.loadStateFromStorage();
    
    this.state = {
      route: 'signin',
      isSignedIn: savedState.isSignedIn || false,
      updateFlag: false,
      isLoading: true,
      error: null,
      userId: '',
      dime: {
        dime_id: '',
        user_id: '',
        rating_count: '',
        category: '',
        image_key: '',
        rating: ''
      },
      robots: savedState.robots || [],
      blockedUsers: savedState.blockedUsers || [],
      searchfield: ''
    }
    this.setStateApp = this.setStateApp.bind(this);
    
    // Load userId immediately in constructor too
    this.loadUserIdSync();
  }

  loadUserIdSync() {
    try {
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        this.state.userId = savedState.user.id;
      }
    } catch (error) {
      console.error('Error in loadUserIdSync:', error);
    }
  }

  loadStateFromStorage() {
    // Don't load from storage if we just deleted something
    if (sessionStorage.getItem('dime-just-deleted')) {
      sessionStorage.removeItem('dime-just-deleted');
      return { robots: [] };
    }
    
    try {
      const savedState = localStorage.getItem('p10-userdimes-state');
      if (savedState) {
        const parsed = JSON.parse(savedState);
        if (!Array.isArray(parsed.robots)) {
          parsed.robots = [];
        }
        return parsed;
      }
    } catch (error) {
      console.error('Error loading state from storage:', error);
    }
    return { robots: [] };
  }

  saveStateToStorage() {
    try {
      const stateToSave = {
        isSignedIn: this.state.isSignedIn,
        robots: this.state.robots,
        blockedUsers: this.state.blockedUsers,
        timestamp: Date.now()
      };
      localStorage.setItem('p10-userdimes-state', JSON.stringify(stateToSave));
    } catch (error) {
      console.error('Error saving state to storage:', error);
    }
  }

  async setStateApp() {
    // ALWAYS ensure userId is set before making any API calls
    this.ensureUserIdSet();
    
    this.setState({ isLoading: true });
    
    try {
      const userId = window.uId || this.state.userId || uId;
      
      if (!userId) {
        console.error('No user ID available in setStateApp');
        this.setState({ 
          isLoading: false,
          error: 'Please sign in to view your dimes'
        });
        return;
      }
      
      const response = await fetch(URL, {
        method: 'post',
        credentials: 'include',
        headers: {'Content-Type': 'application/json'},
        headers: {Authorization: env.API_KEY}, 
        body: JSON.stringify({
        })
      });

      const users = await response.json();
      
      if (typeof users === 'string') {
        console.error('API error:', users);
        this.setState({ 
          isLoading: false,
          error: 'Failed to load dimes'
        });
        return;
      }
      
      const usersArray = Array.isArray(users) ? users : [];
      
      // Re-ensure userId after state update
      this.setState({
        robots: usersArray,
        isLoading: false,
        error: null
      }, () => {
        this.saveStateToStorage();
        // Make sure userId is STILL set after state update
        this.ensureUserIdSet();
      });
    } catch (error) {
      console.error('Error fetching dimes:', error);
      this.setState({ 
        robots: [],
        isLoading: false,
        error: 'Failed to load dimes. Please try again.'
      });
    }
  }

  handleRefresh = () => {
    // Clear localStorage and force refresh
    localStorage.removeItem('p10-userdimes-state');
    this.setState({ 
      robots: [],
      isLoading: true 
    }, () => {
      this.setStateApp();
    });
  }

  // Method that can be called after rating/deleting to refresh the list
  refreshDimesAfterRating = () => {
    console.log('refreshDimesAfterRating: Refreshing user dimes after action');
    this.setStateApp();
  }

  ensureUserIdSet() {
    // CRITICAL: Always try to restore userId from multiple sources
    const storedUserId = this.state.userId;
    
    // First check if window.uId exists
    if (window.uId) {
      // Make sure state matches
      if (this.state.userId !== window.uId) {
        this.setState({ userId: window.uId });
      }
      return; // We're good
    }
    
    // Window.uId is missing, try to restore from state
    if (storedUserId) {
      window.uId = storedUserId;
      window.uIsSignedIn = true;
      return;
    }
    
    // Both are missing, try to load from encrypted storage
    try {
      const savedState = getSecureItem('p10-app-state');
      if (savedState && savedState.user && savedState.user.id) {
        window.uId = savedState.user.id;
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        window.uIsSignedIn = true;
        
        this.setState({ userId: savedState.user.id });
      } else {
        console.error('No user data available in ensureUserIdSet');
      }
    } catch (error) {
      console.error('Error restoring userId:', error);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // ALWAYS ensure window.uId is set on every update - CRITICAL!
    this.ensureUserIdSet();
    
    if (JSON.stringify(prevState.robots) !== JSON.stringify(this.state.robots)) {
      this.saveStateToStorage();
      // Re-ensure after save
      this.ensureUserIdSet();
    }

    if (prevState.updateFlag !== this.state.updateFlag && this.state.updateFlag === true) {
      // Ensure userId before fetching
      this.ensureUserIdSet();
      this.setStateApp();
      this.setState({ updateFlag: false });
    }
  }

  componentDidMount() {
    
    // Add visibility change listener to restore userId when tab becomes active
    this.handleVisibilityChange = () => {
      if (!document.hidden) {
        this.ensureUserIdSet();
      }
    };
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    
    try {
      const savedState = getSecureItem('p10-app-state');
      
      if (savedState && savedState.user && savedState.user.id) {
        // Set all global variables
        window.uFirstName = savedState.user.first_name;
        window.uLastName = savedState.user.last_name;
        window.uRating = savedState.user.rating;
        window.uId = savedState.user.id;
        window.uRatingCount = savedState.user.rating_count;
        window.uImageKey = savedState.user.image_key;
        window.uAdministrator = savedState.user.administrator;
        window.uGender = savedState.user.gender;
        window.uEmail = savedState.user.email;
        window.uJoined = savedState.user.joined;
        window.uProfileImage = savedState.user.profile_image;
        window.uIsSignedIn = true;
        
        // Also set in component state
        this.setState({ userId: savedState.user.id });
        
        this.forceUpdate();
      } else {
        console.error('No user data in encrypted localStorage');
      }
    } catch (error) {
      console.error('Error loading state:', error);
    }
    
    // Only fetch user's dimes
    this.setStateApp();
    this.setState({ updateFlag: true });
  }

  componentWillUnmount() {
    // Clean up listener
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  }

  loadUser = (data) => {
    this.setState({dime: {
      dime_id: '',
      user_id: '',
      rating_count: '',
      category: '',
      image_key: '',
      rating: ''
    }})
  }

  onRouteChange = (route) => {
    if (route === 'signout') {
      this.setState({isSignedIn: false});
      localStorage.removeItem('p10-userdimes-state');
    } else if (route === 'home') {
      this.setState({isSignedIn: true, updateFlag: true});
    }
    this.setState({route: route});
  }
  
  render(){
    // Always ensure userId is set before render
    this.ensureUserIdSet();
    
    const userId = window.uId || this.state.userId || uId;
    const userName = window.uFirstName || uFirstName;
    
    const { isSignedIn, route, isLoading, error } = this.state;
    const { searchField, onSearchChange, isPending } = this.props;
    
    const robotsArray = Array.isArray(this.state.robots) ? this.state.robots : [];
    
    const filteredRobots = robotsArray.filter(robot => {
      return robot && robot.category && 
             robot.category.toLowerCase().includes(searchField.toLowerCase());
    });

    return (
      <div style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
        {/* Modern Top Navigation */}
        <Navbar expand="lg" fixed="top" bg="white" variant="light" style={{ boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Container fluid style={{ maxWidth: '1800px' }}>
            <Navbar.Brand href="/userdimes" style={{ display: 'flex', alignItems: 'center', marginRight: '20px' }}>
              <img src="/images/p10.jpg" alt="P10" style={{ height: '32px', width: '32px', marginRight: '8px',borderRadius: '8px' }}/>
              <span style={{ fontWeight: '600', fontSize: '1.2rem', color: '#1f2937' }}>My Dimes</span>
            </Navbar.Brand>
            
            <div style={{ 
              flex: '1', 
              maxWidth: '900px', 
              margin: '0 20px',
              display: window.innerWidth < 992 ? 'none' : 'block'
            }}>
              <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search your dimes by category..."/>
            </div>
            
            <Navbar.Toggle aria-controls="main-navbar" />
            <Navbar.Collapse id="main-navbar">
              <div style={{ 
                display: window.innerWidth >= 992 ? 'none' : 'block',
                padding: '10px 0'
              }}>
                <PinterestSearchBox searchChange={onSearchChange} searchField={searchField} placeholder="Search your dimes by category..."/>
              </div>
              
              <Nav className="ms-auto">
                <Link to={'/home'} className="nav-link" style={{ fontWeight: '600' }}>
                  <FaHome style={{ marginRight: '6px' }}/> Home
                </Link>
                <Link to={'/profile'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUser style={{ marginRight: '6px' }}/> Profile
                </Link>
                <Link to={'/dimes'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaUsers style={{ marginRight: '6px' }}/> Dimes
                </Link>
                <Link to={'/addDime'} className="nav-link" style={{ fontWeight: '600' }} onClick={() => this.props.clearSearchField()}>
                  <FaPlus style={{ marginRight: '6px' }}/> Add Dimes
                </Link>
                <Link to={'/signin'} className="nav-link" style={{ fontWeight: '600', color: '#e60023' }}>
                  <FaSignOutAlt style={{ marginRight: '6px' }}/> Log out
                </Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>

        {/* Main Content */}
        <Container fluid style={{ paddingTop: '100px', paddingBottom: '100px', maxWidth: '1400px' }}>
          <div className="tc">
            {/* Welcome Header */}
            {userName && (
              <h1 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#1f2937', marginBottom: '10px' }}>
                {userName}'s Dimes Collection
              </h1>
            )}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '40px' }}>
              <h2 style={{ fontSize: '1.5rem', color: '#6b7280', margin: 0 }}>
                Your curated collection of favorites
              </h2>
              <button 
                onClick={this.handleRefresh}
                style={{
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  fontSize: '0.9rem',
                  fontWeight: '600',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px'
                }}
              >
                🔄 Refresh
              </button>
            </div>
            
            {/* Error Alert */}
            {error && (
              <Alert variant="danger" dismissible onClose={() => this.setState({ error: null })}>
                {error}
              </Alert>
            )}
            
            {/* Loading Spinner */}
            {isLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}>
                <Spinner animation="border" role="status" variant="primary">
                  <span className="sr-only">Loading...</span>
                </Spinner>
              </div>
            ) : (
              <>
                {/* No Results Message */}
                {filteredRobots.length === 0 && !isLoading && (
                  <div style={{ textAlign: 'center', padding: '80px 20px' }}>
                    <h2 style={{ color: '#6b7280', marginBottom: '10px' }}>No dimes found</h2>
                    <p style={{ color: '#9ca3af', marginBottom: '20px' }}>
                      {searchField ? 'Try adjusting your search' : 'Start adding dimes to your collection!'}
                    </p>
                    {!searchField && (
                      <Link to="/addDime">
                        <button style={{
                          backgroundColor: '#e60023',
                          color: 'white',
                          border: 'none',
                          padding: '12px 24px',
                          borderRadius: '24px',
                          fontSize: '1rem',
                          fontWeight: '600',
                          cursor: 'pointer',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                        }}>
                          <FaPlus style={{ marginRight: '8px' }}/> Add Your First Dime
                        </button>
                      </Link>
                    )}
                  </div>
                )}
                
                {/* Pinterest-Style Masonry Grid */}
                {filteredRobots.length > 0 && (
                  <UserDimeCardList 
                    setTest={this.setStateApp} 
                    robots={filteredRobots}
                    userId={userId}
                    onRatingSubmitted={this.refreshDimesAfterRating}
                  />
                )}
              </>
            )}
          </div>
        </Container>

        {/* Modern Footer */}
        <div style={{ 
          backgroundColor: 'white',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 0',
          position: 'fixed',
          bottom: 0,
          width: '100%',
          boxShadow: '0 -2px 4px rgba(0,0,0,0.05)'
        }}>
          <Container>
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '20px',
              fontSize: '0.9rem'
            }}>
              <span style={{ color: '#6b7280' }}>© 2025 p10rating</span>
              <Link to="/privacypolicy" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy</Link>
              <Link to="/disclaimer" style={{ color: '#3b82f6', textDecoration: 'none' }}>Disclaimer</Link>
              <Link to="/terms" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</Link>
              <Link to="/about" style={{ color: '#3b82f6', textDecoration: 'none' }}>About</Link>
            </div>
          </Container>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDimes);